module.exports = __webpack_public_path__ + "img/pocket-law-app.da6cc5eb.jpg";